import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'app/shared/modal/modal';
import { fetchPoints } from './actions/getPoints';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Divider } from 'antd';
import classNames from 'classnames';
import { openPickPoint } from './actions/openPickPoint';
import { setShopPoint } from './actions/setShopPoint';
import { CustomModal } from 'app/shared/customModal/customModal';

const SelectPoint = ({
    dispatch,
    isFetching,
    isInvalid,
    response,
    point,
    open,
    settings,
    edit,
}) => {
    useEffect(() => {
        dispatch(fetchPoints());
    }, []);

    function getOnClickPoint(point) {
        dispatch(setShopPoint(point));
        dispatch(openPickPoint(false));
    }
    const points_lists = response.lists || [];
    const content = (
        <>
            {isFetching ? (
                <FontAwesomeIcon
                    className="text-center h1"
                    style={{ display: 'block', margin: '0 auto' }}
                    icon="spinner"
                    pulse={true}
                />
            ) : null}
            {isInvalid ? (
                <h4 className="text-center h1">Ошибка, обновите страницу</h4>
            ) : null}
            {!isFetching && !isInvalid ? (
                !points_lists.length ? (
                    'Филиалы не найдены, попробуйте зайти позже'
                ) : (
                    <>
                        <div className={'pick-point__header'}>
                            {settings?.pointModal?.body?.header}
                        </div>
                        <div className={'pick-point__description'}>
                            {settings?.pointModal?.body?.description}
                        </div>
                        {points_lists.map((item, index, array) => {
                            return (
                                <Fragment key={item.id}>
                                    <div
                                        className={classNames('pick-point', {
                                            'pick-point__active':
                                                point?.id === item.id,
                                        })}
                                        onClick={() => {
                                            if (edit) return;
                                            getOnClickPoint(item);
                                        }}
                                    >
                                        {item.name}
                                    </div>
                                    {index !== array.length - 1 ? (
                                        <Divider />
                                    ) : null}
                                </Fragment>
                            );
                        })}
                    </>
                )
            ) : null}
        </>
    );
    if (edit) return <div className={'pick-point__modal'}>{content}</div>;
    return (
        <CustomModal open={open} className={'pick-point__modal'}>
            {content}
        </CustomModal>
    );
};

const MapStateToProps = function mapStateToProps(state) {
    return {
        isFetching: state.pointsState.points.isFetching,
        didInvalidate: state.pointsState.points.didInvalidate,
        response: state.pointsState.points.response,
        open: state.appState.pickPointModal.isOpen,
        point: state.shopState.order.point,
        settings: state.appState.setting,
    };
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        closeModal: () => {
            dispatch({ type: 'closeMiniModal' });
        },
        dispatch,
    };
};

export const SelectPointLink = connect(
    MapStateToProps,
    mapDispatchToProps
)(SelectPoint);
